/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M22.487 461.482c-11.657 0-21.118-9.461-21.118-21.119V72.605c0-11.658 9.46-21.119 21.118-21.119h268.606c11.658 0 21.119 9.461 21.119 21.119 0 11.657-9.461 21.118-21.119 21.118H43.606v325.522H468.79l-.535-67.77c0-11.685 9.405-21.146 21.09-21.174 11.686 0 21.147 9.405 21.147 21.062l.591 88.944c0 5.604-2.196 11.01-6.167 14.98-3.942 3.97-9.348 6.195-14.951 6.195H22.487z" />
      <path d="M414.93 87.68l86.92 86.92a21.583 21.583 0 013.57 2.883c8.396 8.397 8.396 22.01 0 30.406l-89.803 89.803c-8.396 8.396-22.01 8.396-30.406 0-8.396-8.397-8.396-22.01 0-30.406l56.53-56.531c-60.985-.943-104.905 1.345-140.846 11.7-40.478 11.661-65.219 33.125-76.404 65.182-3.82 10.95-15.795 16.73-26.746 12.91-10.95-3.821-16.73-15.796-12.91-26.746 15.915-45.61 51.453-76.442 104.433-91.705 39.124-11.272 86.16-14.355 145.779-13.487l-50.522-50.523c-8.396-8.396-8.396-22.009 0-30.405s22.01-8.396 30.406 0z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconShare = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconShare.defaultProps = {
  theme,
};
IconShare.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconShare.displayName = 'IconShare';
export { IconShare };
